<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


// State for monitoring current user location [US, UK, EU]
const state = { location: 'us' };

const watched = new Proxy(state, {
  set(target, prop, value) {
    // console.log(`Property "${prop}" changed to:`, value);
    target[prop] = value;
    document.querySelectorAll('.sizes').forEach(el => {
      el.classList.add(state.location);
    });
    return true;
  }
});

// watched.location = 10;  // Triggers the Proxy handler

// Class change for "sizes" container ::

const sizes_container = document.querySelectorAll('.sizes');

// .single-label - quick add
// .text - regular product

sizes_container.forEach(el => {
  const product_size_variants = el.querySelectorAll('.option');
  product_size_variants.forEach(variant => {
    if(watched.location == 'us') {
      if(variant.querySelector('.single-label')) {
        variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[0];
      }
      if(variant.querySelector('.text')) {
        variant.querySelector('.text').innerText = variant.dataset.option.split('/')[0];
      }
    }
    if(watched.location == 'uk') {
      if(variant.querySelector('.single-label')) {
        variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[1];
      }
      if(variant.querySelector('.text')) {
        variant.querySelector('.text').innerText = variant.dataset.option.split('/')[1];
      }
    }
    if(watched.location == 'eu') {
      if(variant.querySelector('.single-label')) {
        variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[2];
      }
      if(variant.querySelector('.text')) {
        variant.querySelector('.text').innerText = variant.dataset.option.split('/')[2];
      }
    }
  })
});

const sizes_clicker = document.querySelectorAll('.sizes_clicker a');

sizes_clicker.forEach(el => {

  // Add active class
  sizes_clicker.forEach(el => {
    if(el.dataset.location == watched.location) {
      el.classList.add('active');
    }
  })

  // Add event listener
  el.addEventListener('click', function(e) {
    e.preventDefault();
    
    watched.location = e.target.dataset.location;

    sizes_clicker.forEach(elm => {
      elm.classList.remove('active');
    });

    // Add active class
    sizes_clicker.forEach(elm => {
      if(elm.dataset.location == watched.location) {
        elm.classList.add('active');
      }
    })

    e.target.classList.add('active');

    sizes_container.forEach(el => {
      const product_size_variants = el.querySelectorAll('.option');
      product_size_variants.forEach(variant => {
        if(watched.location == 'us') {
          if(variant.querySelector('.single-label')) {
            variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[0];
          }
          if(variant.querySelector('.text')) {
            variant.querySelector('.text').innerText = variant.dataset.option.split('/')[0];
          }
        }
        if(watched.location == 'uk') {
          if(variant.querySelector('.single-label')) {
            variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[1];
          }
          if(variant.querySelector('.text')) {
            variant.querySelector('.text').innerText = variant.dataset.option.split('/')[1];
          }
        }
        if(watched.location == 'eu') {
          if(variant.querySelector('.single-label')) {
            variant.querySelector('.single-label').innerText = variant.dataset.option.split('/')[2];
          }
          if(variant.querySelector('.text')) {
            variant.querySelector('.text').innerText = variant.dataset.option.split('/')[2];
          }
        }
      })
    });

  });
});

async function detectRegion() {
  // const res = await fetch("https://ipapi.co/json/");
  // const data = await res.json();

  // const country = data.country; // "US", "GB", "DE", etc.

  // const EU_COUNTRIES = [
  //   "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU",
  //   "IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"
  // ];

  // if (country === "US") return "us";
  // if (country === "GB") return "uk";
  // if (EU_COUNTRIES.includes(country)) return "eu";

  return "us";
}

detectRegion().then(region => {
  watched.location = region;
  // console.log("User region:", region);
});

// Cart modifications

document.addEventListener('DOMContentLoaded', function() {
  const update_cart_content = () => {
    const drawer = document.getElementById('upCart');
    if(drawer) {
      drawer_content = drawer.shadowRoot.getElementById('CartPopup');
      drawer_content.querySelectorAll('.upcart-item-option').forEach(el => {
        console.log(el.dataset);
        if(el.dataset.upcartItemOptionCategory.toLowerCase() == 'sizes') {
          if(watched.location == 'us') {
            if(el.querySelector('.upcart-item-option-value')) {
              el.querySelector('.upcart-item-option-value').innerText = el.dataset.upcartItemOptionValue.split('/')[0];
            }
          }
          if(watched.location == 'uk') {
            if(el.querySelector('.upcart-item-option-value')) {
              el.querySelector('.upcart-item-option-value').innerText = el.dataset.upcartItemOptionValue.split('/')[1];
            }
          }
          if(watched.location == 'eu') {
            if(el.querySelector('.upcart-item-option-value')) {
              el.querySelector('.upcart-item-option-value').innerText = el.dataset.upcartItemOptionValue.split('/')[2];
            }
          }
        }
      });
    }
  }
  window.upcartSubscribeCartOpened(() => {
    update_cart_content();
  });
});